// ====================================================
// ✅ Convertir números a texto en español
// Control de formato: MAYÚSCULAS / minúsculas / Título
// ====================================================

export default function NumeroALetras(num, currency, caseType = 'upper') {

  function Unidades(num) {
      switch(num) {
          case 1: return 'UN';
          case 2: return 'DOS';
          case 3: return 'TRES';
          case 4: return 'CUATRO';
          case 5: return 'CINCO';
          case 6: return 'SEIS';
          case 7: return 'SIETE';
          case 8: return 'OCHO';
          case 9: return 'NUEVE';
          default: return '';
      }
  }

  function Decenas(num) {
      let decena = Math.floor(num / 10);
      let unidad = num - (decena * 10);

      switch(decena) {
          case 1:
              switch(unidad) {
                  case 0: return 'DIEZ';
                  case 1: return 'ONCE';
                  case 2: return 'DOCE';
                  case 3: return 'TRECE';
                  case 4: return 'CATORCE';
                  case 5: return 'QUINCE';
                  default: return 'DIECI' + Unidades(unidad);
              }
          case 2:
              switch(unidad) {
                  case 0: return 'VEINTE';
                  default: return 'VEINTI' + Unidades(unidad);
              }
          case 3: return DecenasY('TREINTA', unidad);
          case 4: return DecenasY('CUARENTA', unidad);
          case 5: return DecenasY('CINCUENTA', unidad);
          case 6: return DecenasY('SESENTA', unidad);
          case 7: return DecenasY('SETENTA', unidad);
          case 8: return DecenasY('OCHENTA', unidad);
          case 9: return DecenasY('NOVENTA', unidad);
          case 0: return Unidades(unidad);
          default: return '';
      }
  }

  function DecenasY(strSin, numUnidades) {
      if (numUnidades > 0)
          return strSin + ' Y ' + Unidades(numUnidades);
      return strSin;
  }

  function Centenas(num) {
      let centenas = Math.floor(num / 100);
      let decenas = num - (centenas * 100);

      switch(centenas) {
          case 1:
              if (decenas > 0)
                  return 'CIENTO ' + Decenas(decenas);
              return 'CIEN';
          case 2: return 'DOSCIENTOS ' + Decenas(decenas);
          case 3: return 'TRESCIENTOS ' + Decenas(decenas);
          case 4: return 'CUATROCIENTOS ' + Decenas(decenas);
          case 5: return 'QUINIENTOS ' + Decenas(decenas);
          case 6: return 'SEISCIENTOS ' + Decenas(decenas);
          case 7: return 'SETECIENTOS ' + Decenas(decenas);
          case 8: return 'OCHOCIENTOS ' + Decenas(decenas);
          case 9: return 'NOVECIENTOS ' + Decenas(decenas);
          default: return Decenas(decenas);
      }
  }

  function Seccion(num, divisor, strSingular, strPlural) {
      let cientos = Math.floor(num / divisor);
      let resto = num - (cientos * divisor);
      let letras = '';

      if (cientos > 0)
          letras = (cientos > 1 ? Centenas(cientos) + ' ' + strPlural : strSingular);

      if (resto > 0)
          letras += ' ';
      return letras;
  }

  function Miles(num) {
      let divisor = 1000;
      let cientos = Math.floor(num / divisor);
      let resto = num - (cientos * divisor);
      let strMiles = Seccion(num, divisor, 'MIL', 'UN MIL');
      let strCentenas = Centenas(resto);

      if (strMiles === '') return strCentenas;
      return strMiles + ' ' + strCentenas;
  }

  function Millones(num) {
      let divisor = 1000000;
      let cientos = Math.floor(num / divisor);
      let resto = num - (cientos * divisor);
      let strMillones = Seccion(num, divisor, 'UN MILLÓN DE', 'MILLONES DE');
      let strMiles = Miles(resto);

      if (strMillones === '') return strMiles;
      return strMillones + ' ' + strMiles;
  }

  // 🔹 Lógica principal
  currency = currency || {};
  let data = {
      numero: num,
      enteros: Math.floor(num),
      centavos: Math.round((num * 100) % 100),
      letrasCentavos: '',
      letrasMonedaPlural: currency.plural || 'SOLES',
      letrasMonedaSingular: currency.singular || 'SOL',
      letrasMonedaCentavoPlural: currency.centPlural || 'CÉNTIMOS',
      letrasMonedaCentavoSingular: currency.centSingular || 'CÉNTIMO'
  };

  if (data.centavos > 0) {
      data.letrasCentavos = 'CON ' + (
          data.centavos === 1
          ? Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular
          : Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural
      );
  }

  let resultado = '';
  if (data.enteros === 0)
      resultado = 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
  else if (data.enteros === 1)
      resultado = Millones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
  else
      resultado = Millones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;

  // 🔠 Conversión según preferencia
  switch (caseType.toLowerCase()) {
      case 'lower':
          resultado = resultado.toLowerCase();
          break;
      case 'title':
          resultado = resultado
              .toLowerCase()
              .replace(/\b\w/g, l => l.toUpperCase());
          break;
      default:
          resultado = resultado.toUpperCase();
  }

  return resultado.trim();
}

// ===============================
// 🧩 Ejemplo de uso
// ===============================

// console.log(
//   NumeroALetras(1234.56, {
//     plural: 'soles',
//     singular: 'sol',
//     centPlural: 'céntimos',
//     centSingular: 'céntimo'
//   }, 'title')
// );
// → "Mil Doscientos Treinta Y Cuatro Soles Con Cincuenta Y Seis Céntimos"

// console.log(
//   NumeroALetras(1234.56, {}, 'lower')
// );
// → "mil doscientos treinta y cuatro pesos con cincuenta y seis centavos"

// console.log(
//   NumeroALetras(1234.56, {}, 'upper')
// );
// → "MIL DOSCIENTOS TREINTA Y CUATRO PESOS CON CINCUENTA Y SEIS CENTAVOS"
